import { createElement } from "react";
import { LUCIDE_PFADE } from "./seiten-icons-pfade";

/**
 * Feste Liste der Lucide-Icons, die eine Seite im Seitenbaum eines Bereichs tragen kann (Musterkatalog M-115, Betreiber 20.10.2026).
 * Die Pfade stehen als Daten in `seiten-icons-pfade.ts` (das Paket bindet `lucide-react` nicht selbst ein, wie `zeilen-symbole.tsx`).
 * Die Namen sind die Quelle für die Anzeige; die Liste, die der Server beim Speichern prüft, steht in
 * `apps/web/src/modules/intranet/lib/bereich-layout.ts` (`SEITEN_ICON_NAMEN`), ein Test hält beide gleich. Ein unbekannter Name
 * zeigt das Standard-Icon (`FileText`), nie etwas anderes.
 */
export const SEITEN_ICON_NAMEN_ANZEIGE = Object.keys(LUCIDE_PFADE).filter((n) => n !== "ArrowRight");

/** Anzeigename einer Icon-Auswahl (Pflege): der Lucide-Name genügt als Beschriftung nicht, darum deutsche Namen. */
export const SEITEN_ICON_LABEL: Record<string, string> = {
  FileText: "Dokument",
  House: "Start",
  Folder: "Ordner",
  Users: "Personen",
  Briefcase: "Aktentasche",
  Truck: "Lieferung",
  Package: "Paket",
  Warehouse: "Lager",
  ShoppingCart: "Einkauf",
  Handshake: "Vereinbarung",
  Scale: "Recht",
  ClipboardList: "Liste",
  Calendar: "Kalender",
  Wrench: "Werkzeug",
  Factory: "Fertigung",
  ShieldCheck: "Sicherheit",
  BookOpen: "Handbuch",
  Map: "Karte",
  Euro: "Kosten",
  Phone: "Telefon",
  Mail: "E-Mail",
  Info: "Information",
  Star: "Favorit",
  Settings: "Einstellungen",
  Lightbulb: "Idee",
  Building2: "Gebäude",
  GraduationCap: "Schulung",
  HeartPulse: "Gesundheit",
  ChartColumn: "Auswertung",
  Megaphone: "Mitteilung",
  Network: "Netzwerk",
  CircleHelp: "Hilfe",
};

/** Ein Lucide-Icon aus den Pfaden; `currentColor`, `aria-hidden` (die Bedeutung trägt der Text daneben, R-F). */
export function LucideSymbol({ name, className = "shrink-0 size-4" }: { name: string; className?: string }) {
  const knoten = LUCIDE_PFADE[name] ?? LUCIDE_PFADE.FileText!;
  return (
    <>
      {/* Preline: navigation-and-layout/navigation-and-layout-sub-sidebars-shells/navigation-and-layout-cat-dashboard-sidebars/classic-dashboard-sidebar-layout (Symbole Lucide inline, AW-123 (4)) */}
      <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {knoten.map(([tag, attribute], i) => createElement(tag, { key: i, ...attribute }))}
      </svg>
    </>
  );
}

/** Das Icon einer Seite im Seitenbaum; unbekannter oder fehlender Name = `FileText`. */
export function SeitenIcon({ name, className = "shrink-0 size-4" }: { name?: string | null; className?: string }) {
  return <LucideSymbol name={name && name !== "ArrowRight" && LUCIDE_PFADE[name] ? name : "FileText"} className={className} />;
}
